{
    "types": [
        {
            "id": "communitySurvey",
            "label": "American Community Survey",
            "geoTypes": [
                "CoastalStates",
                "StateCoastal",
                "ShorelineCounties",
                "WatershedCounties"
            ],
            "description": [
                {
                    "type": "text",
                    "value": "Provides detailed demographic, social, economic, and housing characteristics for coastal geographies in five-year running averages between 2005 and 2019. For more information, see the "
                },
                {
                    "type": "link",
                    "value": "//coast.noaa.gov/data/digitalcoast/pdf/qrt-american-community-description.pdf",
                    "text": "data documentation."
                }
            ],
            "columns": [
                {
                    "field": "geoName",
                    "label": "GeoName"
                },
                {
                    "field": "yearRange",
                    "label": "Year Range"
                },
                {
                    "field": "totalPopulation",
                    "label": "Total Population",
                    "format": "delimited"
                },
                {
                    "field": "malePopulation",
                    "label": "Total Population: Male",
                    "format": "delimited"
                },
                {
                    "field": "femalePopulation",
                    "label": "Total Population: Female",
                    "format": "delimited"
                },
                {
                    "field": "totalHouseholds",
                    "label": "Total Households",
                    "format": "delimited"
                },
                {
                    "field": "populationBelowPovertyLine",
                    "label": "Population Below Poverty Line",
                    "format": "delimited"
                },
                {
                    "field": "renterOccupiedHousing",
                    "label": "Total Renter-Occupied Housing Units",
                    "format": "delimited"
                },
                {
                    "field": "ownerOccupiedHousing",
                    "label": "Total Owner-Occupied Housing Units",
                    "format": "delimited"
                }
            ]
        },
        {
            "id": "coastalEconomy",
            "label": "Coastal Economy (Employment Data)",
            "geoTypes": [
                "CoastalStates",
                "StateCoastal",
                "ShorelineCounties",
                "WatershedCounties",
                "CoastalWatershedStates"
            ],
            "description": [
                {
                    "type": "text",
                    "value": "These data, which include employment statistics and gross domestic product (GDP) for the total economic activity occurring in coastal areas, are generated from Bureau of Labor Statistics Quarterly Census of Employment and Wages and Bureau of Economic Analysis GDP estimates. For more information, see the "
                },
                {
                    "type": "link",
                    "value": "//coast.noaa.gov/data/digitalcoast/pdf/qrt-coastal-economy-description.pdf",
                    "text": "data documentation."
                }
            ],
            "columns": [
                {
                    "field": "geoName",
                    "label": "GeoName"
                },
                {
                    "field": "year",
                    "label": "Year"
                },
                {
                    "field": "sector",
                    "label": "Sector"
                },
                {
                    "field": "establishments",
                    "label": "Establishments",
                    "format": "delimited"
                },
                {
                    "field": "employment",
                    "label": "Employment",
                    "format": "delimited"
                },
                {
                    "field": "wages",
                    "label": "Wages",
                    "format": "currency"
                },
                {
                    "field": "gdp",
                    "label": "GDP",
                    "format": "currency"
                }
            ]
        },
        {
            "id": "demographics",
            "label": "Decadal Demographic Trends",
            "geoTypes": [
                "CoastalStates",
                "StateCoastal",
                "ShorelineCounties",
                "WatershedCounties"
            ],
            "description": [
                {
                    "type": "text",
                    "value": "Includes demographic trends for every decadal census from 1970 to 2010 for 166 variables. Variables include information on age, race, sex, employment, income, and housing. For more information, see the "
                },
                {
                    "type": "link",
                    "value": "//coast.noaa.gov/data/digitalcoast/pdf/qrt-demographic-trends-description.pdf",
                    "text": "data documentation."
                }
            ],
            "columns": [
                {
                    "field": "geoName",
                    "label": "GeoName"
                },
                {
                    "field": "year",
                    "label": "Decade"
                },
                {
                    "field": "totalPopulation",
                    "label": "Total Population",
                    "format": "delimited"
                },
                {
                    "field": "malePopulation",
                    "label": "Total Population: Male",
                    "format": "delimited"
                },
                {
                    "field": "femalePopulation",
                    "label": "Total Population: Female",
                    "format": "delimited"
                },
                {
                    "field": "totalHouseholds",
                    "label": "Total Households",
                    "format": "delimited"
                }
            ]
        },
        {
            "id": "oceanEconomy",
            "label": "Ocean Economy (Employment Data)",
            "geoTypes": [
                "ENOW"
            ],
            "description": [
                {
                    "type": "text",
                    "value": "Provides time-series data on the ocean and Great Lakes economy, which includes six economic sectors dependent on the oceans and Great Lakes. ENOW is available for counties, states, regions, and the nation in a wide variety of formats. For more information, see the "
                },
                {
                    "type": "link",
                    "value": "//coast.noaa.gov/data/digitalcoast/pdf/enow-faq.pdf",
                    "text": "data documentation."
                }
            ],
            "columns": [
                {
                    "field": "geoName",
                    "label": "GeoName"
                },
                {
                    "field": "year",
                    "label": "Year"
                },
                {
                    "field": "sector",
                    "label": "Sector"
                },
                {
                    "field": "establishments",
                    "label": "Establishments",
                    "format": "delimited"
                },
                {
                    "field": "employment",
                    "label": "Employment",
                    "format": "delimited"
                },
                {
                    "field": "wages",
                    "label": "Wages",
                    "format": "currency"
                },
                {
                    "field": "gdp",
                    "label": "GDP",
                    "format": "currency"
                }
            ]
        },
        {
            "id": "selfEmployment",
            "label": "Ocean Economy (Self-Employed Workers)",
            "geoTypes": [
                "ENOW"
            ],
            "description": [
                {
                    "type": "text",
                    "value": "This dataset contains statistics on self-employed workers whose jobs fall within the six sectors of the ocean and Great Lakes economy, as defined by "
                },
                {
                    "type": "link",
                    "value": "//coast.noaa.gov/data/digitalcoast/pdf/enow-nes-crosswalk-table.pdf",
                    "text": "data documentation"
                },
                {
                    "type": "text",
                    "value": ". Statistics include the number of self-employed persons and gross receipts for coastal counties, states, and the coastal United States."
                }
            ],
            "columns": [
                {
                    "field": "geoName",
                    "label": "GeoName"
                },
                {
                    "field": "year",
                    "label": "Year"
                },
                {
                    "field": "sector",
                    "label": "Sector"
                },
                {
                    "field": "employment",
                    "label": "Employment",
                    "format": "delimited"
                },
                {
                    "field": "grossReceipts",
                    "label": "Gross Receipts",
                    "format": "currency"
                }
            ]
        },
        {
            "id": "openEnow",
            "label": "Open ENOW Estimates",
            "geoTypes": [
                "OpenENOW"
            ],
            "description": [
                {
                    "type": "text",
                    "value": "The dataset features time-series data on employment, establishments, wages, and contribution to gross domestic product (GDP) in multiple economic sectors that are dependent on the oceans and Great Lakes. Open ENOW provides estimates for the years 2001-2024 at the region, state, and national levels. Open ENOW draws on less detailed data than the established ENOW dataset and uses imputed values to fill in data gaps. Estimates from Open ENOW are historically very similar to the established ENOW data, but not identical."
                },
                {
                    "type": "link",
                    "value": "",
                    "text": ""
                }
            ],
            "columns": [
                {
                    "field": "geoName",
                    "label": "GeoName"
                },
                {
                    "field": "year",
                    "label": "Year"
                },
                {
                    "field": "sector",
                    "label": "Sector"
                },
                {
                    "field": "establishments",
                    "label": "Establishments",
                    "format": "delimited"
                },
                {
                    "field": "employment",
                    "label": "Employment",
                    "format": "delimited"
                },
                {
                    "field": "wages",
                    "label": "Wages",
                    "format": "currency"
                },
                {
                    "field": "gdp",
                    "label": "GDP",
                    "format": "currency"
                }
            ]
        }
    ]
}